<template>
<transition name="modal">
  <div class="modal-mask">
		<div class="modal-wrapper">
			<div class="modal-container" :class="this.id">
        <button class="modal-close" @click="$store.toggleModal('')">
          <svg
            class="icon-close"
            width="100%"
            height="100%"
            viewBox="0 0 24 24">
            <g transform="translate(5.345 5.937)">
              <path d="M-13546.376-15348.6l10.722,10.722" transform="translate(13546.376 15348.597)" fill="none" stroke="#fff" stroke-linecap="round" stroke-width="1"/>
              <path d="M-13535.654-15348.6l-10.722,10.722" transform="translate(13546.376 15348.597)" fill="none" stroke="#fff" stroke-linecap="round" stroke-width="1"/>
            </g>
          </svg>
        </button>

				<div class="modal-body">
          <Scrollable>
          <slot name="content">
            <p>Modal content lorem ipsum dolor sit, amet consectetur adipisicing elit. Quis ipsam laboriosam exercitationem nulla perferendis iusto, ad quos iste. Cumque, maxime!</p>
          </slot>
          </Scrollable>
				</div>
			</div>
		</div>
    <div class="modal-overlay" @click="$store.toggleModal('')"></div>
	</div>
  </transition>
</template>

<script>
import Scrollable from '@/components/Scrollable.vue';

export default {
  name: 'Modal',
  props: {
    id: String,
  },
  components: {
    Scrollable
  }
};
</script>

<style lang="scss" scoped>
@import '~@/scss/styles.scss';

.scrollable-container {
  height: 100vh;

  @include breakpoint(md) {
    height: 500px;
  }
}

.modal-overlay {
  z-index: 9998;
  background-color: rgba(0, 0, 0, .5);
}

.modal-mask {
  z-index: 9997;
}

.modal-mask, .modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  display: table;
  transition: opacity .3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  width: 100%;
  height: 100vh;
  margin: 0px auto;
  padding: 40px 0 0;
  background-color: $blue-dark;
  transition: all .3s ease;
  position: relative;
  z-index: 9999;

  @include breakpoint(sm) {
    // padding: 0;
    // display: flex;
    // align-items: center; 
    // justify-content: center;
  }

  @include breakpoint(md) {
    width: 100%;
    height: 100%;
  }
}

.modal-header h3 {
  margin-top: 0;
}

.modal-body {
  margin: 20px;
}

.modal-close {
  position: absolute;
  top: 0;
  right: 0;
  width: 48px;
  height: 48px;
  margin: 0;
  padding: 0;
  background: none;
  border: none;
  z-index: 5;
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

</style>
